import React, { useContext } from "react"

import MicrocopyContext from "~contexts/MicrocopyContext"
import DeprecatedItem from "./DeprecatedItem"

const DeprecatedItems = ({ deprecatedItems }) => {
  const microcopy = useContext(MicrocopyContext)

  return (
    <>
      {(deprecatedItems || []).map((item) => (
        <DeprecatedItem key={item.id} item={item} microcopy={microcopy} />
      ))}
    </>
  )
}

export default DeprecatedItems
